export class CipherBulkRestoreRequest {
    ids: string[];

    constructor(ids: string[]) {
        this.ids = ids == null ? [] : ids;
    }
}
